'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:timeRange');
}

var _invoke = require('../invoke');

/**
 * 选择出行日期
 *
 *
 * @memberof train
 * @static
 * @name timeRange
 * @param {Number} start 开始时间
 * @param {Number} end 结束时间
 * @return {Promise<date>}
 * @example
 *  hbnb.train.timeRange(12, 15)
 *      .then(function(range) {
 *          range = {
 *              start: 0,
 *              end: 24
 *          }
 *      });
 */
module.exports = function(start, end) {
    if (process.env.NODE_ENV !== 'production') {
        debug('start is %s', start);
        debug('end is %s', end);
    }

    if (start === undefined) {
        start = 0;
        end = 24;
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('train', 'time_range', {
            start: start,
            end: end,
            callback: function(range) {
                resolve(range);
            }
        });
    });
    return p;
};
